import PaymentDatatable from '@/components/Payments/PaymentDatatable.vue';
import InvoiceWebView from '@/components/Payments/InvoiceWebView.vue';

const PaymentRoutes = [
    {
        path: "/payments",
        name: "Payments",
        meta: {
            requiresAuth: true
        },
        components: {
            page: PaymentDatatable
        }
    }
];

export default PaymentRoutes;
